import { render } from "./showmax.vue?vue&type=template&id=06c36815&scoped=true"
import script from "./showmax.vue?vue&type=script&lang=js"
export * from "./showmax.vue?vue&type=script&lang=js"

import "./showmax.vue?vue&type=style&index=0&id=06c36815&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tap-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c36815"]])

export default __exports__